<style scoped lang="less" src="../../assets/Home.less"></style>
<template>
  <div class="home-page">
    <HeaderTpl :title="'开讲'" :backTrack="'djk-kj-home_back'"></HeaderTpl>
    <template v-if="catagoryList && catagoryList.length > 0">
      <div class="nav-wap">
        <ul class="nav-list" data-track="djk-kj-home_category_click">
          <li v-for='(item, index) in catagoryList'
              class="nav-item"
              :class="{'cur': (!currentCatagoryId && index === 0) || item.id==currentCatagoryId}"
              @click='switchTab(item, index)'>{{item.name}}
          </li>
        </ul>
        <div class="navdown" @click="showNavBox=true" data-track="djk-kj-home_category_unfold"></div>
      </div>
    </template>
    <!--<template v-if="advertList && advertList.length > 0">
      <mt-swipe :auto="4000" class="banner-wap">
        <mt-swipe-item v-for='item in advertList' :key="item.id">
          <img :src="item.imgUrl" :alt="item.title" @click="swipeLink(item)"/>
        </mt-swipe-item>
      </mt-swipe>
    </template>-->
    <template v-if="showNavBox">
      <div class="nav-box">
        <div class="nav-box-head">
          <p>
            全部分类
          </p>
          <div class="navhide" @click="showNavBox=false" data-track="djk-kj-home_category_fold"></div>
        </div>
        <ul class="nav-box-list" data-track="djk-kj-home_category_click">
          <li
            v-for='(item, index) in catagoryList'>
            <a
              href="javascript:;"
              :class="item.id==currentCatagoryId ? 'on':''"
              @click='switchTab(item, index)'>{{item.name}}</a>
          </li>
        </ul>
      </div>
      <div class="mask" @touchend="showNavBox=false"></div>
    </template>
    <div class="course-wap">
      <div class="netError" v-if="error">
        <img src="../../assets/images/home/netError@2x.png" alt="网络出错"/>
        <p>网络出错</p>
        <a href="javascript:location.reload();">刷新重试</a>
      </div>
      <template v-else>
        <div class="empty_wrap" v-if="!courseList || courseList.length <= 0">
          <div class="empty">
            <img src="../../assets/images/home/empty@2x.png" alt="暂时没有课程"/>
            <p>暂无课程~</p>
          </div>
        </div>
        <template v-for='item in courseList' v-else>
        <div class="course" v-if="item">
          <template>
            <div class="tit">
              {{item.statsDesc}}
              <i v-if="item.startStatus==2">&nbsp;|&nbsp;可以继续畅听</i>
              <!--<span>{{item.count}}个课程</span>-->
            </div>
            <ul class="course-list">
              <li v-for='classitem in item.list' @click="goToClass(classitem)" :data-id="classitem.id">
                <div class="video-box">
                  <img :src="classitem.picture">
                  <p class="video-status processing"
                     v-if="item.startStatus==1"><i></i><span>进行中</span></p>
                  <p class="video-status start"
                     v-else-if="item.startStatus==0">
                    <template v-if="classitem.time">
                      <span>{{classitem.time}}</span>
                    </template>
                    <template v-else>
                      <i v-if="classitem.countTime"></i><span>{{classitem.countTime ? classitem.countTime : ''}}</span>
                    </template>
                  </p>
                  <p class="video-status"
                     v-else-if="item.startStatus==2"><span class="go-on">继续畅听</span></p>
                </div>
                <div class="info">
                  <p class="tit-info"><span class="serial-icon" v-if="classitem.type === 2"></span>{{classitem.name}}</p>
                  <p class="expert">
                    {{classitem.expertName}}&nbsp;&nbsp;{{classitem.expertTitle}}
                  </p>
                  <p class="price-join">
                    <span class="hasbug-icon" v-if="classitem.hasBuy"></span>
                    <span class="price" v-if="!classitem.hasBuy">￥{{classitem.price}}</span>
                    <del class="old-price" v-if="!classitem.hasBuy">￥{{classitem.lastPrice}}</del>
                    <ScoreLabel :data="classitem.pointDTO" type="list"></ScoreLabel>
                    <span class="join-cont" v-if="classitem.joinNum >= 10">{{classitem.joinNum}}人参加</span>
                  </p>
                </div>
              </li>
            </ul>
          </template>
        </div>
        </template>
        <div class="show-none" v-if="courseList && courseList.length > 0">
          ── {{isBottom?'已经到底啦':'加载中'}} ──
        </div>
      </template>
    </div>
    <!-- 页面loading -->
    <loading :isLoading="isLoading"></loading>
    <GoTop></GoTop>
    <AdTip></AdTip>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import Loading from '@/components/Loading';
  import GoTop from '@/components/GoTop';
  import AdTip from '@/components/AdTip';
  import { Swipe, SwipeItem } from 'mint-ui';
  import HeaderTpl from '@/components/Header';
  import report from '@/mixins/report';

  export default {
    name: 'HomePage',
    components: { Loading, Swipe, SwipeItem, HeaderTpl, GoTop, AdTip },
    mixins: [report],
    data() {
      return {
        currentCatagoryId: null,
        canScroll: false,
        startStatus: null,
        nextPageNum: null,
        timer: null,
        delay: 0,
        showNavBox: false,
        error: false,
        DOREPORT: false
      };
    },
    computed: {
      ...mapGetters({
        isLoading: 'isLoading',              // 是否显示加载蒙层
        catagoryList: 'catagoryList',        // 分类列表
        advertList: 'advertList',              // 首页列表
        courseList: 'indexCourseList',              // 首页列表
        indexCourseObj: 'indexCourseObj',              // 首页列表
        userInfo: 'userInfo',
        errors: 'error',
        isLoading1: 'isLoading'
      }),
      isBottom() {
        return typeof this.startStatus === 'undefined';
      },
      canBack() {
        return window.history.length > 0;
      }
    },
    created() {
      window.addEventListener('scroll', this.handleScroll);
    },
    mounted() {
      this.initPage(true);
    },
    destroyed() {
      this.clearIntervals();
      window.removeEventListener('scroll', this.handleScroll);
    },
    watch: {
      currentCatagoryId() {
        if (this.currentCatagoryId !== null) {
          this.$store.dispatch('getIndexList', {
            catagoryId: this.currentCatagoryId,
            newPage: true
          });
        }
      },
      catagoryList: {
        handler() {
          this.DOREPORT = true;
          this.$nextTick(() => {
            if (this.$route.query.category) {
              this.catagoryList.forEach((item, index) => {
                if (Number(item.id) === Number(this.$route.query.category)) {
                  this.switchTab(item, index);
                }
              });
            } else if (!this.currentCatagoryId) {
              this.currentCatagoryId = this.catagoryList[0].id;
            }
          });
        }
      },
      indexCourseObj() {
        this.updateData();
        this.startStatus = this.indexCourseObj.startStatus;
        this.nextPageNum = this.indexCourseObj.nextPageNum;
      },
      userInfo: {
        handler() {
          this.initPage(true);
          location.hash = location.hash.split('?')[0];
        },
        deep: true
      }
    },
    methods: {
      initPage(reload) {
        if ((this.courseList && this.courseList.length < 1) || reload) {
          this.currentCatagoryId = null;
          this.$store.dispatch('getCatagory');
        }
        this.updateData();
        this.startStatus = this.indexCourseObj.startStatus;
        this.nextPageNum = this.indexCourseObj.nextPageNum;
      },
      handleScroll() {
        if (this.canScroll) {
          return;
        }
        this.canScroll = true;
        setTimeout(() => {
          this.canScroll = false;
          const scrollTop = document.body.scrollTop + document.documentElement.scrollTop;
          const scrollHeight = document.body.scrollHeight;
          const clientHeight = document.documentElement.clientHeight;
          if (scrollHeight - scrollTop < clientHeight * 1.5) {
            this.getNextPage();
          }
        }, 800);
      },
      getNextPage() {
        console.log(this.startStatus, this.nextPageNum, this.indexCourseObj);
        if (typeof this.startStatus !== 'undefined') {
          this.$store.dispatch('getIndexList', {
            catagoryId: this.currentCatagoryId,
            startStatus: this.startStatus,
            curpage: this.nextPageNum,
            newPage: false
          });
        }
      },
      switchTab(item, index) {
        this.currentCatagoryId = item.id;
        this.showNavBox = false;
        const target = document.querySelectorAll('.nav-item')[index];
        const offset = target.offsetLeft - document.querySelector('.nav-list').scrollLeft;
        console.log(offset);
        if (offset > 190 || offset < 0) {
          document.querySelector('.nav-list').scrollLeft = target.offsetLeft - 50;
        }
      },
      clearIntervals() {
        if (this.timer) {
          clearInterval(this.timer);
        }
      },
      showTime(index, course, i) {
        const startDate = new Date(course.startTime);
        this.courseList[index].list[i].start = `${startDate.getHours()}:${startDate.getMinutes()}`;
        // 如果开始时间超过1天，显示开始日期，小于一天显示倒计时，已经开始显示已开始
        if (course.startTime - course.currentTime <= 86400 * 1000) {
          // this.countDown(index, course, i);
        } else if (course.startTime - course.currentTime > 86400 * 1000) {
          this.courseList[index].list[i].time = this.formatTime(course);
        }
      },
      renderTime(timestamp) {
        let [h, m, s] = [0, 0, 0];
        s = parseInt(timestamp % 60, 10);
        m = parseInt(timestamp / 60, 10);
        if (m > 60) {
          h = parseInt(m / 60, 10);
          m %= 60;
        }
        return `${this.toZero(h)}:${this.toZero(m)}:${this.toZero(s)}`;
      },
      formatTime(course) {
        const month = this.toZero(new Date(course.startTime).getMonth() + 1);
        const date = this.toZero(new Date(course.startTime).getDate());
        const hour = this.toZero(new Date(course.startTime).getHours());
        const minte = this.toZero(new Date(course.startTime).getMinutes());
        return `${month}月${date}日 ${hour}:${minte}`;
      },
      toZero(num) {
        if (num < 10) {
          num = `0${num}`;
        }
        return num;
      },
      updateData() {
        this.clearIntervals();
        this.courseList.forEach((list, index) => {
          // 未开始课程显示倒计时
          if (list.startStatus === 0 && list.list.length > 0) {
            list.list.forEach((course, i) => {
              this.showTime(index, course, i);
            });
            this.countdown(list.list, index);
          }
        });
      },
      countdown(list, index) {
        // 每秒循环一次，计算所有需要倒计时的时间
        if (list.length > 0) {
          this.delay = Date.parse(new Date()) - list[0].currentTime;
        }
        this.timer = setInterval(() => {
          const now = Date.parse(new Date());
          list.forEach((course, i) => {
            let text = '00:00:00';
            if (course.startTime - now <= 86400 * 1000) {
              if (now - this.delay < course.startTime) {
                text = this.renderTime(((course.startTime - now) + this.delay) / 1000);
              }
            }
            this.$set(this.courseList[index].list[i], 'countTime', text);
          });
        }, 1000);
      },
      goToClass(item) {
        if (item.price > 0 && this.userInfo.token) {
          if (!item.join) {
            // 收费未付费
            this.$router.push({ name: 'LiveInfo', params: { liveId: item.id } });
          } else if (item.join && item.startStatus === 1) {
            // 收费已付费且进行中
            this.$router.push({ name: 'liveMessages', params: { liveId: item.id } });
          } else if (item.join && (item.startStatus === 0 || item.startStatus === 2)) {
            // 收费已付费且未开始或已结束
            this.$router.push({ name: 'LiveInfo', params: { liveId: item.id } });
          }
        } else if (item.price === 0 && this.userInfo.token) {
          if (!item.join) {
            // 免费未付费
            this.$router.push({ name: 'LiveInfo', params: { liveId: item.id } });
          } else if (item.join && item.startStatus === 1) {
            // 免费已付费且进行中
            this.$router.push({ name: 'liveMessages', params: { liveId: item.id } });
          } else if (item.join && (item.startStatus === 0 || item.startStatus === 2)) {
            // 免费已付费且未开始或已结束
            this.$router.push({ name: 'LiveInfo', params: { liveId: item.id } });
          }
        } else {
          this.$router.push({ name: 'LiveInfo', params: { liveId: item.id } });
        }
        // 埋点
        if (item.startStatus === 2) {
          window.Tracking.initTrackUrl(2, 'djk-kj-home_lessons_over_click', '');
        } else if (item.startStatus === 1) {
          window.Tracking.initTrackUrl(2, 'djk-kj-home_lessons_ing_click', '');
        } else if (item.startStatus === 0) {
          window.Tracking.initTrackUrl(2, 'djk-kj-home_lessons_ready_click', '');
        }
      }
    }
    /* beforeRouteLeave(to, from, next) {
      if (to.name === 'LiveInfo' || to.name === 'liveMessages') {
        window.location.href = `${window.location.origin}/live${to.fullPath}`;
      } else {
        next();
      }
    }, */
  };
</script>



// WEBPACK FOOTER //
// Home.page.vue?5f7b052e